import { render, staticRenderFns } from "./LevelEdit.vue?vue&type=template&id=13185010&scoped=true"
import script from "./LevelEdit.vue?vue&type=script&lang=ts"
export * from "./LevelEdit.vue?vue&type=script&lang=ts"
import style0 from "./LevelEdit.vue?vue&type=style&index=0&id=13185010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13185010",
  null
  
)

export default component.exports